import {Layout} from "../layouts";
import {ShippingData} from "@/components/shipping-and-returns";

const ShippingAndReturns: React.FC = () => {
    return (
        <Layout page={"shipping"}>
            <ShippingData heading={""} content={""}/>
        </Layout>
    );
};

export default ShippingAndReturns;
